import type { Tile } from '../types/mjai';

/**
 * Returns the display number for a tile (red 5 shows as 5).
 */
export function getTileNumber(tile: Tile): string {
  if (tile === '?' ) return '?';
  const num = tile[0] === '0' ? '5' : tile[0];
  return num;
}

export function getTileSuit(tile: Tile): string {
  return tile[1] ?? '';
}

export function isRedFive(tile: Tile): boolean {
  return tile[0] === '0';
}

export function isHonor(tile: Tile): boolean {
  return tile[1] === 'z';
}

export function tileToSortKey(tile: Tile): number {
  if (tile === '?') return 999;
  const suitOrder: Record<string, number> = { m: 0, p: 1, s: 2, z: 3 };
  const suit = tile[1] ?? 'z';
  const num = tile[0] === '0' ? 5 : parseInt(tile[0]);
  return (suitOrder[suit] ?? 3) * 100 + num;
}

export function sortTiles(tiles: Tile[]): Tile[] {
  return [...tiles].sort((a, b) => tileToSortKey(a) - tileToSortKey(b));
}

/**
 * Count occurrences of each tile in an array.
 */
export function countTiles(tiles: Tile[]): Record<string, number> {
  const counts: Record<string, number> = {};
  for (const t of tiles) {
    counts[t] = (counts[t] ?? 0) + 1;
  }
  return counts;
}

/**
 * Normalize red fives to their normal counterpart for counting purposes.
 * e.g. '0m' -> '5m'
 */
export function normalizeTile(tile: Tile): Tile {
  if (tile[0] === '0') return '5' + tile[1];
  return tile;
}

/**
 * Returns a human-readable tile label.
 */
export function getTileLabel(tile: Tile): string {
  if (tile === '?') return '?';
  const honorLabels: Record<string, string> = {
    '1z': '東', '2z': '南', '3z': '西', '4z': '北',
    '5z': '白', '6z': '発', '7z': '中',
  };
  if (tile[1] === 'z') return honorLabels[tile] ?? tile;
  const suitLabel = tile[1] === 'm' ? '萬' : tile[1] === 'p' ? '筒' : '索';
  const num = tile[0] === '0' ? '赤5' : tile[0];
  return `${num}${suitLabel}`;
}

/**
 * All valid tile codes (excluding red fives for listing purposes).
 */
export const ALL_TILES: Tile[] = [
  '1m','2m','3m','4m','5m','6m','7m','8m','9m',
  '1p','2p','3p','4p','5p','6p','7p','8p','9p',
  '1s','2s','3s','4s','5s','6s','7s','8s','9s',
  '1z','2z','3z','4z','5z','6z','7z',
];

export const RED_FIVES: Tile[] = ['0m', '0p', '0s'];
